<template>
  <div
    class="modals"
  >
    <transition
      name="fade"
      appear
    >
      <div
        v-if="activeChild"
        class="backdrop"
      />
    </transition>
    <transition
      name="bounce"
    >
      <!-- we need v-if twice for the transitions to work -->
      <component
        v-if="activeChild"
        :path="activeChild.getters.path"
        :is="activeChild.getters.type"
        v-bind="activeChild.getters.props"
        :close-func="closeModal"
      />
    </transition>
  </div>
</template>

<script>
import BaseModule from '@/components/modules/BaseModule'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'modalController',
  extends: BaseModule,
  data () {
    return {
      lastPath: '/'
    }
  },
  computed: {
    activeChild () {
      if (this.$route.path.startsWith(this.path)) {
        const childName = this.$route.path.split(this.path, 2)[1].split('/', 3)[1]
        return this.$store.getters.childrenByName[childName]
      }
      return false
    }
  },
  created () {
    if (!this.$route.path.startsWith('/modals')) {
      this.lastPath = this.$route.path
    }
    // register links for modals
    for (const child of this.$store.getters.children) {
      this.$root.$store.dispatch('registerLink', {
        group: 'modal',
        titleFunc: () => child.getters.props.title,
        href: child.getters.path
      })
    }
  },
  beforeDestroy () {
    // unregister links for modals
    this.$root.$store.dispatch('unregisterGroup', {
      group: 'modal'
    })
  },
  methods: {
    closeModal () {
      this.$router.push(this.lastPath)
    }
  },
  watch: {
    '$route.path' (newPath) {
      if (!this.isActive) {
        this.lastPath = newPath
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* overwrite animation defaults */
.fade-leave-active {
  animation-delay: 0.6s;
}

.bounce-enter-active {
  animation-delay: 0.3s;
}

.modals {
  height: 100vh;
  width: 100vw;
}

.backdrop {
  background-color: rgba($color: #000, $alpha: 0.85);
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: z(modal);
}
</style>
